import React, { useState, useEffect } from "react";
import ReactTable from "react-table";
import Pagination from "../../../components/DatatablePagination";
import { injectIntl } from "react-intl";
import IntlMessages from "../../../helpers/IntlMessages";

// Một component nhỏ để render checkbox, giúp code gọn gàng hơn
const CheckboxCell = ({ value }) => (
  <div style={{ textAlign: "center" }}>
    <input
      type="checkbox"
      checked={value === true} // Chỉ check khi giá trị là true
      readOnly // Ngăn người dùng thay đổi trực tiếp
    />
  </div>
);

export default injectIntl((props) => {
  // console.log(props);
  const { intl } = props;
  const [state, setState] = useState({
    columns: [],
  });

  useEffect(() => {
    setState({
      ...state,
      columns: [
        {
          columns: [
            {
              Header: (
                <span>
                  <IntlMessages id="pages.product-name" />{" "}
                  <span style={{ color: "red" }}>*</span>
                </span>
              ),
              accessor: "name",
              minWidth: 150,
            },
            {
              Header: <IntlMessages id="table.import.sku" />,
              accessor: "sku",
              minWidth: 100,
            },
            {
              Header: <IntlMessages id="table.import.barcode" />,
              accessor: "barcode",
              minWidth: 120,
            },
            {
              Header: (
                <span>
                  <IntlMessages id="pages.category" />{" "}
                  <span style={{ color: "red" }}>*</span>
                </span>
              ),
              accessor: "category",
              minWidth: 120,
            },
            {
              Header: (
                <span>
                  <IntlMessages id="table.import.price_sale" />{" "}
                  <span style={{ color: "red" }}>*</span>
                </span>
              ),
              accessor: "price",
              minWidth: 100,
            },
            {
              Header: <IntlMessages id="table.import.price_promotion" />,
              accessor: "price_sale",
              minWidth: 100,
            },
            {
              Header: <IntlMessages id="table.import.apply_promotion" />,
              accessor: "active_sale",
              Cell: ({ value }) => <CheckboxCell value={value} />,
              style: { textAlign: "center" },
              minWidth: 80,
            },
            {
              Header: <IntlMessages id="table.import.tax-rate" />,
              accessor: "tax_rate",
              minWidth: 90,
              Cell: ({ value }) => <span>{value ? `${value}%` : "0%"}</span>,
            },
            {
              Header: <IntlMessages id="table.import.image" />,
              accessor: "image",
              minWidth: 150,
              Cell: ({ value }) =>
                value ? (
                  <span
                    title={value}
                    style={{
                      display: "block",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      maxWidth: 140,
                    }}
                  >
                    {value}
                  </span>
                ) : (
                  "-"
                ),
            },
            {
              Header: <IntlMessages id="table.import.image_sub" />,
              accessor: "images",
              minWidth: 150,
              Cell: ({ value }) =>
                value ? (
                  <span
                    title={value}
                    style={{
                      display: "block",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      maxWidth: 140,
                    }}
                  >
                    {value}
                  </span>
                ) : (
                  "-"
                ),
            },
            {
              Header: <IntlMessages id="table.import.recommend" />,
              accessor: "bestter",
              Cell: ({ value }) => <CheckboxCell value={value} />,
              style: { textAlign: "center" },
              minWidth: 80,
            },
            {
              Header: <IntlMessages id="table.import.hidden" />,
              accessor: "softHide",
              Cell: ({ value }) => <CheckboxCell value={value} />,
              style: { textAlign: "center" },
              minWidth: 80,
            },
            {
              Header: <IntlMessages id="table.import.description" />,
              accessor: "description",
              minWidth: 180,
              Cell: ({ value }) =>
                value ? (
                  <span
                    title={value}
                    style={{
                      display: "block",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      maxWidth: 170,
                    }}
                  >
                    {value}
                  </span>
                ) : (
                  "-"
                ),
            },
            {
              Header: <IntlMessages id="table.import.size" />,
              accessor: "size",
              minWidth: 150,
              Cell: ({ value }) =>
                value ? (
                  <span
                    title={value}
                    style={{
                      display: "block",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      maxWidth: 140,
                    }}
                  >
                    {value}
                  </span>
                ) : (
                  "-"
                ),
            },
            {
              Header: <IntlMessages id="table.import.topping" />,
              accessor: "topping",
              minWidth: 150,
              Cell: ({ value }) =>
                value ? (
                  <span
                    title={value}
                    style={{
                      display: "block",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      maxWidth: 140,
                    }}
                  >
                    {value}
                  </span>
                ) : (
                  "-"
                ),
            },
            {
              Header: <IntlMessages id="table.import.ice" />,
              accessor: "ice",
              minWidth: 130,
              Cell: ({ value }) =>
                value ? (
                  <span
                    title={value}
                    style={{
                      display: "block",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      maxWidth: 120,
                    }}
                  >
                    {value}
                  </span>
                ) : (
                  "-"
                ),
            },
            {
              Header: <IntlMessages id="table.import.sugar" />,
              accessor: "sugar",
              minWidth: 130,
              Cell: ({ value }) =>
                value ? (
                  <span
                    title={value}
                    style={{
                      display: "block",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      maxWidth: 120,
                    }}
                  >
                    {value}
                  </span>
                ) : (
                  "-"
                ),
            },
            {
              Header: (
                <span>
                  <IntlMessages id="product.price.cost" />{" "}
                  <span style={{ color: "red" }}>*</span>
                </span>
              ),
              accessor: "stock_cost_price",
              minWidth: 100,
              style: { textAlign: "right" },
            },
            {
              Header: (
                <span>
                  <IntlMessages id="warehouse.import-quantity" />{" "}
                  <span style={{ color: "red" }}>*</span>
                </span>
              ),
              accessor: "stock_quantity",
              minWidth: 80,
              style: { textAlign: "right" },
            },
            {
              Header: <IntlMessages id="table.import.color" />,
              accessor: "color",
              minWidth: 120,
              Cell: ({ value }) =>
                value ? (
                  <span
                    title={value}
                    style={{
                      display: "block",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      maxWidth: 110,
                    }}
                  >
                    {value}
                  </span>
                ) : (
                  "-"
                ),
            },
            {
              Header: <IntlMessages id="table.import.material" />,
              accessor: "material",
              minWidth: 120,
              Cell: ({ value }) =>
                value ? (
                  <span
                    title={value}
                    style={{
                      display: "block",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      maxWidth: 110,
                    }}
                  >
                    {value}
                  </span>
                ) : (
                  "-"
                ),
            },
          ],
        },
      ],
    });
  }, []);

  return (
    <ReactTable
      defaultPageSize={10}
      data={props.data}
      columns={state.columns}
      minRows={0}
      showPageJump={false}
      showPageSizeOptions={true}
      PaginationComponent={Pagination}
      NoDataComponent={() => null}
    />
  );
});
